import { BaseEdge, EdgeLabelRenderer, getBezierPath } from "@xyflow/react";

export const NoEdge = ({
	id,
	sourceX,
	sourceY,
	targetX,
	targetY,
}: {
	id: string;
	sourceX: number;
	sourceY: number;
	targetX: number;
	targetY: number;
}) => {
	const [edgePath, labelX, labelY] = getBezierPath({
		sourceX,
		sourceY,
		targetX,
		targetY,
	});

	return (
		<>
			<BaseEdge id={id} path={edgePath} />
			<EdgeLabelRenderer>
				<div
					className="nodrag nopan"
					style={{
						position: "absolute",
						color: "#DF2800",
						transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
						background: "#FFD9DA",
						padding: "2px 8px",
						borderRadius: 5,
						fontSize: 12,
						fontWeight: 700,
					}}
				>
					No
				</div>
			</EdgeLabelRenderer>
		</>
	);
};
